import * as React from "react";
import type { SVGProps } from "react";
const SvgRulerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="ruler_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M898.56 253.568 774.357 129.28a165.973 165.973 0 0 0-234.752 0L129.28 539.563a165.973 165.973 0 0 0 0 234.752l124.288 124.288a165.973 165.973 0 0 0 234.752 0L898.603 488.32a165.973 165.973 0 0 0 0-234.752zm-60.33 60.33a80.64 80.64 0 0 1 0 114.091L427.99 838.23a80.64 80.64 0 0 1-114.091 0L189.61 713.984a80.64 80.64 0 0 1 0-114.09l3.242-3.2c1.579 2.474 3.499 4.82 5.675 6.997l106.496 106.496a42.667 42.667 0 0 0 60.33-60.331L258.86 543.36a43.05 43.05 0 0 0-6.998-5.675l63.574-63.573a42.667 42.667 0 0 0 2.261 2.475l54.827 54.869a42.667 42.667 0 0 0 60.373-60.373l-54.87-54.87a43.264 43.264 0 0 0-2.474-2.261L431.19 358.4a42.581 42.581 0 0 0 5.675 6.997L543.36 471.893a42.667 42.667 0 0 0 60.33-60.33L497.196 305.067a43.008 43.008 0 0 0-6.998-5.675l55.595-55.637c.725.853 1.493 1.706 2.304 2.474l54.827 54.827a42.667 42.667 0 1 0 60.373-60.33l-54.87-54.87a43.008 43.008 0 0 0-2.133-2.005 80.683 80.683 0 0 1 107.691 5.76L838.23 313.899z"
    />
  </svg>
);
export default SvgRulerIcon;
